<span class="app-color-swatch__dot" [style.background]="color()"></span>
@if (showLabel()) {
    <span class="app-color-swatch__label">{{ color() }}</span>
}
